import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const ViewLeaveRequestModal = ({ isOpen, toggle, leave }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Leave Request Details</ModalHeader>
            <ModalBody style={{
                wordWrap: 'break-word',
                overflowY: 'auto',
                maxHeight: '80vh'
            }}>
                {leave && (
                    <div>
                        <p><strong>Reason:</strong> {leave.leaveReason}</p>
                        <p><strong>Type:</strong> {leave?.leaveType?.name || leave?.leaveType || '-'}</p>
                        <p>
                            <strong>From Date:</strong>{' '}
                            {(() => {
                                const d = new Date(leave.fromDate);
                                const day = String(d.getDate()).padStart(2, '0');
                                const month = String(d.getMonth() + 1).padStart(2, '0');
                                const year = d.getFullYear();
                                return `${day}-${month}-${year}`;
                            })()}
                        </p>
                        <p>
                            <strong>To Date:</strong>{' '}
                            {(() => {
                                const d = new Date(leave.toDate);
                                const day = String(d.getDate()).padStart(2, '0');
                                const month = String(d.getMonth() + 1).padStart(2, '0');
                                const year = d.getFullYear();
                                return `${day}-${month}-${year}`;
                            })()}
                        </p>
                        <p><strong>Status:</strong> {leave.status}</p>
                        {leave.class && <p><strong>Class:</strong> {leave.class}</p>}
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
};

export default ViewLeaveRequestModal;
